
  export default {
    props: {
      modalBasket: {
        type: Array,
        default: [
          {
            quantity: 1,
            name: "",
          },
        ],
        required: true,
      },
      // quantity is only required for bundles
      quantity: {
        type: Number,
        default: 1
      },
      // pass in prop of 'bundle=true' if it's a bundle
      bundle: {
        type: Boolean,
        default: false
      }
    },

    mounted() {
    },
    computed: {
      isMobile() {
        return this.$store.getters.getIsMobile;
      },
    },
    methods: {
      hideBasketModal() {
        this.$emit('hide-basket-modal', "Basket modal hidden")
      },
      goToBasket() {
        this.$emit('navigate-to-basket', "Navigate to basket")
      }
    }
  };
